import React, { useState } from 'react';
import './ContactUs.css';
import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";
// import Footer from './Footer';
// import { useForm, ValidationError } from '@formspree/react';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
    
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const response = await fetch('https://formspree.io/f/xqaerklv', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });

    if (response.ok) {
      setFormData({ name: '', email: '', message: '' });
      setStatus('Message sent successfully!');
    } else {
      setStatus('Message failed to send. Please try again.');
    }
  };

  return (
    <div>
      <div className='maincontainer'>
        <div className='left-one'>
          <h3 className="road">Take The Road To </h3>
          <h1 className=" business "> Grow Your Business</h1>
          <div className="icon">
            <h4 className='expert'>Expert Team Members</h4>
            <h4 className='expert' >Experienced Specialists</h4>
            <h4 className='expert'>Skilled Professionals
            </h4>

          </div>
          <h4 className='premium-one'>
           PREMIUM DIGITAL AGENCY
          </h4>
          <div className="icon">
            <a href="https://facebook.com/share/191tCpdMHP/?mibextid=qi2Omg" target="_blank" rel="noopener noreferrer">
              <FaFacebook className="fb-one" /> 
              </a>
            <a href="https://instagram.com/balajiitservices?igsh=eWg0aXE4Z21weW4=" target="_blank" rel="noopener noreferrer">
              <FaInstagram className="fb-one"  />
            </a>
            <a href="https://linkedin.com/in/balajiitservices" target="_blank" rel="noopener noreferrer">
              <FaLinkedin className="fb-one" />
            </a>

          </div>

        </div>
        <div className='right-one'  >
          <h2 className="convo ">Start A Conversation With Us  </h2>
          <h1 className='contact'> Contact Us</h1>


          <div className="contact-form-container">
      <form onSubmit={handleSubmit} className="contact-form">
        <label>Name</label>
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
        />

        <label>Email</label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
        />

        <label>Message</label>
        <textarea
          name="message"
          value={formData.message}
          onChange={handleChange}
          required
        ></textarea>

        <button type="submit">Send Message</button>

        {status && <p className="form-status">{status}</p>}
      </form>
     
    </div>

        </div>
      </div>
      {/* <Footer /> */}
    </div>
  );
};

export default ContactUs;

